import { Route } from "@angular/router";
import { DotationComponent } from "./dotation.component";
import { EditDotationRouting } from "./edit-dotation/edit-dotation-routing";
import { AddArticleRouting } from "./add-article/add-article.routing";

export const DotationRouting: Route = {
  path: "dotation",
  component: DotationComponent,
  data: {
    breadcrumb: "Dotation"
  },
  children: [
    EditDotationRouting,
    AddArticleRouting
  ]
};
